import { createContext } from 'react';
export var AccordionItemContext = /*#__PURE__*/createContext({});